import * as React from 'react';
import styled from 'styled-components';

import { SelectIcon, Button } from '../material-ui';
import { VoucherIcon } from './VoucherIcon';

const StyledButton = styled(Button)`
	padding: 0 1rem 0 0 !important;
	overflow: hidden;
	height: 4rem;
`;

const ImageLabel = styled.img`
	height: 4rem;
	background-color: white;
`;

const Label = styled.span`
	margin: 0 1rem;
`;

export const SelectButton = ({ image, iconName, title, onClick }) => (
	<StyledButton variant="contained" onClick={onClick} color={title ? 'primary' : 'default'}>
		{image && <ImageLabel src={image} alt="" />}
		{iconName && <VoucherIcon name={iconName} size="4rem" noBackground />}
		<Label>{title || 'auswählen'}</Label>
		<SelectIcon />
	</StyledButton>
);



// WEBPACK FOOTER //
// ./src/components/SelectButton.js